import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=690094b6&scoped=true&"
import script from "./selectRole.vue?vue&type=script&lang=js&"
export * from "./selectRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690094b6",
  null
  
)

export default component.exports